import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import "../../../../css/PaginaProducto/ProductoEspecifico.css"
import axios from "axios";
import SaveAltIcon from '@mui/icons-material/SaveAlt';

export const DiseñoCuatro = ({ producto, categoria }) => {
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const handleDescargar = () => {
        if (producto.pdf) {
            const url = `${backendURL}/${producto.pdf}`;
            window.open(url, '_blank');
        }
    };

    const descargar = async () => {
        if (!producto.id) return;

        try {
            const url = `${backendURL}/api/producto/${producto.id}/descargar-pdf`;

            const response = await axios.get(url, {
                responseType: 'blob', // importante para archivos binarios
            });
            handleDescargar();
            // Crear un blob con el tipo correcto
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

            // Crear un enlace para descargar
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(pdfBlob);

            // Nombre del archivo (puedes personalizarlo)
            link.download = 'ficha-tecnica.pdf';

            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error al descargar PDF:', error);
        }
    };
    return (
        <Box >
            {/* titulo categoria */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'center',

                }}>
                <h1 className="TituloPaginaProducto">{categoria.titulo}</h1>
                <h1 className="Titulo1PaginaProducto">{categoria.titulo1}</h1>
            </Box>

            <Box sx={{
                marginTop: '100px',
                '@media (max-width:600px)': {
                    marginTop: '10px',
                },
            }}>
                <Grid container spacing={2}>
                    <Grid size={{ sm: 12, md: 6 }} sx={{

                        display: "flex", alignItems: 'center', justifyContent: 'center', flexDirection: 'column'
                    }}>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'flex-end',
                                justifyContent: 'flex-end'
                            }}>
                            {producto.logo_empresa_maquina && (
                                <Box
                                    className='ImagenLogoEmpresaMaquinaPaginaEspecificas'
                                    sx={{
                                        display: "none",
                                        '@media (max-width:899px)': {
                                            display: "flex"
                                        },
                                    }}

                                >
                                    <img
                                        src={`${backendURL}/${producto.logo_empresa_maquina}`}
                                        alt="logo"
                                        title="logo"

                                    />
                                </Box>
                            )}
                        </Box>
                        <Box sx={{ width: '80%' }}>
                            {producto.imagen_producto && (
                                <img
                                    src={`${backendURL}/${producto.imagen_producto}`}
                                    alt="hod"
                                    title="hod"
                                    width='100%'
                                />
                            )}
                        </Box>




                    </Grid>
                    <Grid size={{ sm: 12, md: 6 }}>
                        <Box>
                            {/* imagen logo maquina */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: "center",
                                    justifyContent: "flex-end"
                                }}>
                                <Box className='ImagenLogoEmpresaMaquinaPaginaEspecificas' sx={{
                                    display: "flex",
                                    '@media (max-width:899px)': {
                                        display: "none"
                                    },
                                }}
                                >
                                    {producto.logo_empresa_maquina && (
                                        <img
                                            src={`${backendURL}/${producto.logo_empresa_maquina}`}
                                            alt="hod"
                                            title="hod"
                                        />
                                    )}
                                </Box>
                            </Box>
                            {/* informacion producto */}
                            <Box className='infoProductoMaquina' sx={{
                                marginTop: '100px', '@media (max-width:899px)': {
                                    marginTop: '40px'
                                },
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    '@media (max-width:899px)': {
                                        alignItems: "center",
                                        justifyContent: 'center'
                                    }
                                }}>
                                    <Typography variant="subtitle1" sx={{ mb: -3, color: producto.color || '#1A425B', fontFamily: 'Montserrat', fontWeight: 500, fontSize: '2.2rem', textTransform: 'uppercase', '@media (max-width:400px)': { fontSize: '1.5rem' } }}>{producto.titulo_maquina}</Typography>
                                    <Typography variant="subtitle1" sx={{ m: 0, color: producto.color || '#1A425B', fontFamily: 'Montserrat', fontWeight: 700, fontSize: '2.2rem', textTransform: 'uppercase', '@media (max-width:400px)': { fontSize: '1.5rem' } }}>{producto.nombre_maquina}</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: '80%',
                                        marginTop: '30px',
                                        display: 'flex',
                                        '@media (max-width:408px)': {
                                            width: '100%',
                                        },
                                    }}>

                                    <Box
                                        sx={{
                                            width: '10px',
                                            backgroundColor: producto.color || '#1A425B',
                                            borderRadius: '4px  4px',
                                            margin: '1px'
                                        }}
                                    />
                                    <Box>
                                        <Box className="cardvisionproducto">
                                            <h4>{producto.descripcion_vision}</h4>
                                        </Box>
                                        <Box className="cardvisionproducto">
                                            <h4>{producto.texto_innovacion}</h4>
                                        </Box>
                                    </Box>


                                </Box>



                            </Box>
                        </Box>
                    </Grid>

                </Grid>
            </Box>
            <Box sx={{
                marginTop: '100px',
                display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                flexDirection: 'column'
            }}>
                <Typography variant="subtitle1" sx={{
                    color: producto.color || '#1A425B',
                    fontSize: '2rem',
                    fontWeight: '600',
                    fontFamily: 'Montserrat',
                    textTransform: 'uppercase',
                    '@media (max-width:550px)': {
                        fontSize: '1rem'
                    }
                }}>Características</Typography>
                <div className="tablavasos">
                    {producto.logo_dispositivo && (
                        <img
                            src={`${backendURL}/${producto.logo_dispositivo}`}
                            alt="hod"
                            title="hod"
                        />
                    )}
                </div>
            </Box>
             <Box
      sx={{
        mt:20,
        display:'flex',
        alignItems:'center', 
        justifyContent:'center'
      }}>
{producto.pdf && (
  <button
    onClick={descargar}
    className="anchobotondescarga"
    style={{
      '--boton-color': producto.color || '#1A425B',
    }}
  >
    <SaveAltIcon sx={{ marginRight: '10px', fontSize: '2rem' }} />
    <p style={{ margin: 0 }}>Descargar ficha técnica</p>
  </button>
)}
      </Box>
        </Box>
    )
}